import _en from './en';
import _ja from './ja';

export const EN = _en;
export const JA = _ja;
